








































import { ActivityIcon } from '@/components';
import { RecentActivity } from '@/models/dashboard';
import { buildGeekName } from '@/utils';
import moment from 'moment';
import Vue from 'vue';

export default Vue.extend({
  name: 'RecentActivityTile',
  components: {
    ActivityIcon,
  },
  props: {
    activity: Object as () => RecentActivity,
    isLoading: Boolean,
  },
  computed: {
    activityTimeText(): string {
      return moment(this.activity.dateTime).fromNow();
    },
  },
  methods: {
    goToGeeksProfile() {
      return this.$router.push({name: 'geek-profile', params: { geekId: this.activity.geekId }});
    },
    buildGeekName,
  },
});
